import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import { useDocumentosGeneralesMutations } from '../../hooks';
//import {getClientes} from "../../services/Clientes";
import { ButtonSubmit, FooterPages } from '..';

const initialState = {
empresa:'',
documentoGeneral: '',
descripcion: '',
exigeFecha: 'SI',
vigencia: 0,
tipo: 'Logística',
};

const NuevoDocuGeneral = ({vecinoData, onChangeVecino}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const { addDocuGeneral , updateDocuGeneralC } = useDocumentosGeneralesMutations();
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  useEffect(() => {
    if(vecinoData) setFormData(vecinoData);
  }, [vecinoData]);

  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) =>{
    e.preventDefault();

    // Validaciones

    if(!vecinoData) 
    {
      // console.log('crear VECINO');
       await addDocuGeneral.mutateAsync(formData);
    } else
    { 
       await updateDocuGeneralC.mutateAsync(formData);
    };
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevodocugeneral );

  }
  
  return (
    <form  onSubmit={handleSubmit} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
        <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-2/3 p-8">

            <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
              <div className="flex items-center gap-2">
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
                <p className="text-gray-800 font-semibold text-base md:text-lg">
                  {!vecinoData ? "Nuevo" : "Editar"} Documentación General
                </p>
              </div>

              <button
                type="button"
                onClick={() => setIsClicked(!isClicked.nuevodocugeneral)}
                className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
                aria-label="Cerrar"
              >
                <MdOutlineCancel className="text-xl md:text-2xl" />
              </button>
            </div>

          <div className="mt-5 space-y-4">
          <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Documento General</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="documentoGeneral"
                      value= {formData.documentoGeneral}
                      required
                      onChange={handleChange}
                    />
                </div>
                <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Descripción</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="descripcion"
                        value= {formData.descripcion}
                        required
                        onChange={handleChange}
                      />
                  </div>
                </div>
                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Tipo</label>
                      <select className={inputClass} name="tipo" value={formData.tipo} required onChange={handleChange}>
                        <option value="Logística">Logística</option>
                        <option value="Obra">Obra</option>
                        <option value="Anexo">Anexo</option>
                      </select>
                  </div>
                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Exige Fecha</label>
                      <select className={inputClass} name="exigeFecha" value= {formData.exigeFecha} required onChange={handleChange}>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                  </div>

                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Días Vigencia</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="vigencia"
                        value= {formData.vigencia}
                        required
                        onChange={handleChange}
                      />
                  </div>
              </div>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                  <button
                      onClick={handleSubmit}
                      className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                  >
                    { !vecinoData ? "Crear Nuevo": "Guardar Cambios"} 
                  </button>
              </div>           
              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevoDocuGeneral;